import React from "react";
import { useTranslation } from "react-i18next";

const MAP = {
  OPEN: { key: "state.pickYourXI", cls: "bg-[#b6ff2e] text-black" },
  LOCKED: { key: "state.locked", cls: "bg-neutral-700 text-neutral-200" },
  REVEALED: { key: "state.lineupsOut", cls: "bg-[#3fd7e5] text-black" },
  IN_PLAY: { key: "state.live", cls: "bg-red-600 text-white animate-pulse" },
  SETTLED: { key: "state.resultReady", cls: "bg-[#ffb547] text-black" },
};

export function StateBadge({ state, testid }) {
  const { t } = useTranslation();
  const m = MAP[state] || MAP.OPEN;
  return (
    <span data-testid={testid}
      className={`px-2.5 py-1 rounded-full text-[11px] font-display font-bold uppercase tracking-wide ${m.cls}`}>
      {t(m.key)}
    </span>
  );
}
